export default __webpack_public_path__ + "static/1886-2c09adab7d37cc5aea61e095ced5c67b.gif";